<template>
  <div id="car-add" class="sav-wrapper">
    <Topbar/>
		<div class="sav-container">
      <Header back="/new" title="Νέα ασφάλεια αυτοκινήτου" category="car"/>
      <Add category="car" :id="id" :cardHeaders="carHeaders" />
    </div>
  </div>
</template>

<script>
import Topbar from './../Topbar.vue'
import Header from './../Header.vue'
import Add from './../Add.vue'
import carHeaders from './../../../public/data/db.car-single-headers.json'

export default {
	props: ['id'],
    components: {
    Topbar,
    Header,
    Add
  },
  data() {
    return {
      carHeaders: carHeaders
    }
	}
}
</script>

<style lang="scss" scoped>
</style>
